import React from 'react';
import { Title } from '../../Components/Header';

export default function E404(props) {
	return <>
		<Title.Input>Krajské volby {props.year}</Title.Input>
		<h2>Error 404 - stránka nenalezena</h2>
	</>;
}
